
import httpClient, { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import serializeObject from '@/utils/serializeObject'
import * as Settings from '@/infra/settings'

export const apiGetSinisters = (
  sinisterId,
  complementaryRef,
  sinisterStatus,
  page
) => {
  const params = {
    sinister_id: sinisterId,
    complementary_ref: complementaryRef,
    status_id: sinisterStatus,
    page
  }

  const hasParams = sinisterId || complementaryRef || sinisterStatus || page
  return httpClient
    .get(`sinister/${hasParams ? '?' + serializeObject(params) : ''}`)
    .then(data => data)
}

export const apiGetSinister = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient
    .get(`sinister/address${paramsToString(params)}`)
    .then(data => data)
}

export const apiPostSinister = (
  sinisterId,
  zipCode,
  moreThanTwoYears,
  propertyType,
  residentType,
  lat,
  lon,
  addressSin,
  showExtraInfo
) => {
  return httpClient
    .post('sinister/address', {
      sinister_id: sinisterId,
      zip_code: zipCode,
      more_than_two_years: moreThanTwoYears,
      real_estate: propertyType,
      declarant: residentType,
      lat: lat,
      lon: lon,
      address: addressSin,
      show_extra_info: showExtraInfo
    })
    .catch(error => {
      const errorCodes = [400, 500, 409]
      const errorCode =
                errorCodes.find(errorCode => error.response.status === errorCode) || 0

      return Promise.reject(errorCode)
    })
}

export const apiPostSinisterId = (sinisterId, eventId) => {
  const params = {
    sinister_id: sinisterId
  }
  if (eventId) params.event_id = eventId

  return httpClient.post('sinister/', params)
}

export const apiGetSinisterStatuses = () => {
  return httpClient.get('sinister/statuses/').then(data => data)
}

export const apiPatchRepairType = body => {
  return httpClient.post('sinister/update', body).then(data => data)
}

export const getSelfcareLinkData = sinisterId => {
  const params = new URLSearchParams()
  params.append('locale', Settings.getLocale())
  params.append('sinisterId', sinisterId)

  return billmaHttpClient
    .get(`/claims/selfcare-link${paramsToString(params)}`)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
